'use client';

import { FunctionComponent } from 'react';
import { TooltipPlacement, useBreakpoints } from '@monorepo/nova-ui';
import { useDiscordButton } from '../../hooks';
import {
  StyledDiscordButtonWrapper,
  StyledDiscordDesignIcon,
  StyledDiscordIcon,
  StyledDiscordIconButton,
  StyledDiscordTooltip,
} from '../../styles/discord-button.styled';

export const DiscordButton: FunctionComponent = () => {
  const { isMobile, isDesktop } = useBreakpoints();
  const { isEnabled, tooltipMessage, ariaLabel, handleClick } =
    useDiscordButton();

  return (
    <StyledDiscordButtonWrapper isEnabled={isEnabled} isDesktop={isDesktop}>
      <StyledDiscordTooltip
        title={tooltipMessage}
        placement={TooltipPlacement.Bottom}
      >
        <span style={{ display: 'inline-flex' }}>
          <StyledDiscordIconButton
            onClick={handleClick}
            aria-label={ariaLabel}
            disabled={!isEnabled}
            isMobile={isMobile}
            isEnabled={isEnabled}
          >
            <StyledDiscordIcon>
              <StyledDiscordDesignIcon
                isEnabled={isEnabled}
                iconName={isEnabled ? 'DiscordEnabled' : 'DiscordDisabled'}
                useMuiSvgIcon={false}
              />
            </StyledDiscordIcon>
          </StyledDiscordIconButton>
        </span>
      </StyledDiscordTooltip>
    </StyledDiscordButtonWrapper>
  );
};
